import { styled, Typography, useTheme } from '@mui/material';
import { useAtomValue } from 'jotai/index';
import * as React from 'react';
import { useWatch } from 'react-hook-form';
import { IField } from '../../../data-models/field2.data-model';
import { currencyMapByCodeAtom } from '../../../services/state/AppConfigStateJ';
import { Formatting } from '../../../types';
import { getMetricUnit } from '../../../util/field-utils';

const CellWrapper = styled('div')`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr min-content;
`;

export interface IMetricNameCellProps {
  metric: IField<unknown>;
  editMode?: boolean;
}
export function MetricNameCell(props: IMetricNameCellProps) {
  const theme = useTheme();
  const { metric, editMode } = props;

  const inputCurrencyCode = useWatch({
    name: `kpiData.currencyCode`,
  });

  const isCurrency = metric.formMeta?.renderer?.type === 'currency';
  const metricCurrencyCode =
    isCurrency && metric.formMeta?.renderer?.id !== 'currency' ? metric.formMeta?.renderer?.id : 'USD';

  const currencyCodeForm = editMode ? inputCurrencyCode : metricCurrencyCode;
  const currencyMapByCode = useAtomValue(currencyMapByCodeAtom);

  const metricCurrency = React.useMemo(
    () => currencyMapByCode.get(currencyCodeForm ?? 'USD') ?? null,
    [currencyCodeForm, currencyMapByCode]
  );

  return (
    <CellWrapper>
      <Typography variant={'body2'}>{metric.displayName}</Typography>
      <Typography color={theme.colors.neutral[40]}>
        {isCurrency ? metricCurrency?.symbol : getMetricUnit(metric.formMeta?.renderer?.id as Formatting)}
      </Typography>
    </CellWrapper>
  );
}
